import initialstate from '../../initialstate';
import * as types from '../../../actions/actiontypes';

export default function drillDownTimePhaseReducer(state = initialstate.drillDownTimePhaseDetails, action) {
	switch (action.type) {
		case types.GET_TIMEPHASES: {
			let drillDownTimePhaseDetails = [...action.response.items];
			return drillDownTimePhaseDetails;
		}
		default:
			return state;
	}
}
